import { Flex, Box, Text } from '@chakra-ui/react'
import { Image as ChakraImage } from '@/components/HOC/Image'
import { useTranslation } from 'next-i18next/pages'
import LootboxBannerImage2 from '@/public/assets/images/lootbox/banner-image.png'
import { RulesButton } from '@/components/atoms/RulesButton/RulesButton'
import { GameRules } from 'types/types'

export const LootboxBanner = () => {
  const { t } = useTranslation()
  return (
    <Box pt={{ base: 12, md: 8 }} overflow={'hidden'}>
      <Flex
        pos={'relative'}
        bgImage={'/assets/images/lootbox/banner.png'}
        bgPos={{ base: 'left', md: 'right' }}
        bgSize={'cover'}
        mb={10}
        h={{ base: 'auto', md: '350px' }}
        p={{ base: 5, md: 6, xl: 10 }}
        pt={{ base: 48, sm: 56, md: 6, xl: 10 }}
        rounded={'2xl'}
        flexDir={{ base: 'column', md: 'row' }}
      >
        <ChakraImage
          loading="eager"
          position={'absolute'}
          right={{ base: '50%', md: 0, xl: 20 }}
          bottom={{ base: 'auto', md: 0, xl: -12 }}
          top={{ base: -10, sm: -16, md: 'auto' }}
          transform={{ base: 'translateX(50%)', md: 'none' }}
          h={'auto'}
          priority={true}
          quality={100}
          w={{ base: 328, sm: 448, md: 450, xl: 600 }}
          src={LootboxBannerImage2}
          alt={''}
        />
        <Flex
          maxW={{ base: 'none', lg: '450px' }}
          flexDirection={'column'}
          justifyContent={'center'}
          position={'relative'}
          alignItems={'start'}
          h={'full'}
          zIndex={20}
          pos={'relative'}
        >
          <Text fontSize={{ base: '3xl', sm: '32px', md: '40px', xl: '52px' }} lineHeight={1} mb={3} fontWeight={700}>
            {t('lootbox.banner-title')}
          </Text>
          <Text
            maxW={{ base: 'auto', md: '330px', xl: '390px' }}
            fontSize={{ base: 'sm', xl: 'base' }}
            mb={4}
            fontWeight={500}
            color={'ninja.100'}
          >
            {t('lootbox.banner-description')}
          </Text>
          <Box zIndex={30} pos={'relative'}>
            <RulesButton
              styles={{
                height: '54px',
              }}
              game={GameRules.LOOTBOX}
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

// import { LootboxLimited, LootboxMetadata, LootboxState, LootboxType } from '../templates/transformLootboxRewards'
// import LootboxBannerImage from '@/public/assets/images/lootbox/banner-lootbox.png'
// import LootboxBannerStones from '@/public/assets/images/lootbox/lootbox-banner-stones.png'
// import LootboxBannerStonesMobile from '@/public/assets/images/lootbox/lootbox-banner-stones-mobile.png'
// import Link from 'next/link'
// import { GET_LOOTBOX_GAME_COUNT, GET_LOOTBOX_SALES } from '@/api/query'

// const LootboxBannerOld = () => {
//   const { getBannerLootbox } = useLootboxContext()
//   const lootbox = getBannerLootbox()

//   return (
//     <Box overflow={'hidden'}>
//       <Flex
//         pos={'relative'}
//         bgImage={'/assets/images/lootbox/banner.png'}
//         bgPos={{ base: 'left', md: 'right' }}
//         bgSize={'cover'}
//         mb={10}
//         p={{ base: 5, md: 6, xl: 10 }}
//         pt={{ base: 36, sm: 6, xl: 10 }}
//         rounded={'2xl'}
//         flexDir={{ base: 'column', md: 'row' }}
//         mt={{ base: 12, md: 8 }}
//       >
//         <ChakraImage
//           loading="eager"
//           position={'absolute'}
//           right={{ base: '50%', sm: 12, md: 20, xl: 135 }}
//           bottom={{ base: 'auto', md: 0, xl: 5 }}
//           top={{ base: -16, sm: -12, md: 'auto' }}
//           transform={{ base: 'translateX(50%)', sm: 'none' }}
//           h={'auto'}
//           priority={true}
//           quality={100}
//           w={{ base: 220, sm: 220, md: 350, xl: 410 }}
//           src={LootboxBannerImage}
//           alt={''}
//         />
//         <ChakraImage
//           display={{ base: 'none', xl: 'block' }}
//           right={0}
//           bottom={0}
//           loading="eager"
//           position={'absolute'}
//           src={LootboxBannerStones}
//           alt=""
//         />
//         <ChakraImage
//           display={{ base: 'block', xl: 'none' }}
//           right={{ base: '50%', sm: 0 }}
//           top={{ base: -4, sm: 0, md: 12 }}
//           transform={{ base: 'translateX(50%)', sm: 'none' }}
//           w={{ base: '320px', md: '510px' }}
//           loading="eager"
//           position={'absolute'}
//           src={LootboxBannerStonesMobile}
//           alt=""
//         />

//         <Box zIndex={10} lineHeight={1} fontWeight={700}>
//           <Flex
//             flexDir={{ base: 'row', sm: 'column', md: 'row', xl: 'column' }}
//             gap={{ base: 3, md: 5 }}
//             alignItems={{ base: 'center', sm: 'start', md: 'center', xl: 'start' }}
//             mb={2}
//           >
//             <Badge />
//             <Text
//               bg={'#5D52EE'}
//               bgBlendMode={'overlay'}
//               bgGradient={`linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0.5) 33%, rgba(255, 255, 255, 0.25) 66%, rgba(255, 255, 255, 0.25) 75%, rgba(255, 255, 255, 0.25) 100%)`}
//               backgroundClip={'text'}
//               __css={{
//                 '-webkit-text-fill-color': 'transparent',
//               }}
//               lineHeight={1.2}
//               fontSize={{ base: 'md', md: 'md', xl: '2xl' }}
//             >
//               Grab your reward!
//             </Text>
//           </Flex>
//           <Text maxW={{ base: 300, xl: 'none' }} mb={1} fontSize={{ base: '40px', md: '40px', xl: '56px' }}>
//             {lootbox?.title}
//           </Text>
//           <Text
//             mb={{ base: 4, md: 4, xl: 7 }}
//             fontSize={{ sm: 'sm', md: 'sm', xl: 'md' }}
//             lineHeight={1.25}
//             color={'whiteAlpha.600'}
//             fontWeight={500}
//           >
//             Get an exclusive reward and
//             <br /> boost your gaming experience.
//           </Text>
//           <Flex flexDir={{ base: 'column-reverse', xl: 'row' }} gap={{ base: 3, md: 3, xl: 4 }}>
//             {lootbox?.type === LootboxType.LIMITED && <AfterLimitedCTA lootbox={lootbox} />}
//             {lootbox?.type === LootboxType.UNLIMITED && <UnlimitedCTA lootbox={lootbox} />}
//           </Flex>
//         </Box>
//       </Flex>
//     </Box>
//   )
// }

// const UnlimitedCTA = ({ lootbox }: { lootbox: LootboxUnlimited & LootboxMetadata }) => {
//   return (
//     <Link href={'/lootbox/' + lootbox?.contract}>
//       <Button px={12} py={7} h={'60px'} rounded={'xl'}>
//         Buy
//       </Button>
//     </Link>
//   )
// }

// import { useQuery } from '@apollo/client'
// import { ProgressBar } from '../atoms/ProgressBar'
// import { useLootboxContext } from '@/context/LootboxProvider'
// import { RulesButton } from '@/components/atoms/RulesButton/RulesButton'
// import { GameRules } from 'types/types'

// const LimitedCTA = ({ lootbox }: { lootbox: LootboxLimited & LootboxMetadata }) => {
//   const { data, loading, error } = useQuery(GET_LOOTBOX_SALES, {
//     variables: {
//       id: lootbox?.limited.contracts.sale,
//     },
//   })

//   const isSoldOut = data?.lootboxSale?.salesCount == lootbox.limited.quantity

//   return (
//     <>
//       <Link href={'/lootbox/' + lootbox?.contract}>
//         <Button px={12} py={7} h={'60px'} rounded={'xl'}>
//           {isSoldOut || lootbox.state === LootboxState.BLOCKED ? 'View' : 'Buy'}
//         </Button>
//       </Link>
//       {loading || error ? (
//         <Skeleton w={'full'} minW={'280px'} rounded={'xl'} h={'61px'} startColor="ninja.200" endColor="ninja.300" />
//       ) : (
//         <ProgressBar
//           totalCount={data?.lootboxSale?.salesCount || 0}
//           totalLimit={lootbox.limited.quantity}
//           text={data?.lootboxSale?.salesCount == lootbox.limited.quantity ? 'Sold out!' : undefined}
//           version={'banner'}
//         />
//       )}
//     </>
//   )
// }

// const AfterLimitedCTA = ({ lootbox }: { lootbox: LootboxLimited & LootboxMetadata }) => {
//   const { data, loading, error } = useQuery(GET_LOOTBOX_GAME_COUNT, {
//     variables: {
//       id: lootbox?.contract,
//     },
//   })

//   return (
//     <>
//       <Link href={'/lootbox/' + lootbox?.contract}>
//         <Button px={12} py={7} h={'60px'} rounded={'xl'}>
//           View
//         </Button>
//       </Link>
//       {loading || error ? (
//         <Skeleton w={'full'} minW={'280px'} rounded={'xl'} h={'61px'} startColor="ninja.200" endColor="ninja.300" />
//       ) : (
//         <ProgressBar
//           title="Remaining Supply"
//           totalCount={data?.lootbox?.gameCount || 0}
//           totalLimit={lootbox.limited.quantity}
//           version={'banner'}
//         />
//       )}
//     </>
//   )
// }

// const Badge = () => {
//   return (
//     <Text
//       bgGradient={`linear-gradient(96deg, #A245FF -1.27%, #BD78FF 95.78%);`}
//       display={'inline-block'}
//       px={2}
//       py={2}
//       fontSize={'xs'}
//       rounded={'lg'}
//     >
//       Limited Edition
//     </Text>
//   )
// }
